import { ApolloLink, Observable } from '@apollo/client';
import { getGlobalSkipAllQueries } from './AuthenticationContext';

// Create a completely blocking link for logout
const BlockingLink = new ApolloLink(() => {
  return new Observable(() => {
    // Do nothing - completely block all operations
  });
});

// Create a conditional link that switches between normal and blocking behavior
export const SkipAllQueriesLink = new ApolloLink((operation, forward) => {
  const shouldSkip = getGlobalSkipAllQueries();

  if (shouldSkip) {
    return BlockingLink.request(operation);
  }
  return forward(operation);
});
